import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 12\" id=\"icon-arrow-left\"><path d=\"M6.71.71a.996.996 0 0 0-1.41 0L.71 5.3a.996.996 0 0 0 0 1.41L5.3 11.3a.996.996 0 1 0 1.41-1.41L2.83 6l3.88-3.88c.39-.39.38-1.03 0-1.41z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol